// Calculate distance between two points using Haversine formula
export const calculateDistance = (point1, point2) => {
  const R = 6371; // Earth's radius in kilometers
  const lat1 = Number(point1.latitude);
  const lon1 = Number(point1.longitude);
  const lat2 = Number(point2.latitude);
  const lon2 = Number(point2.longitude);

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c; // Distance in kilometers
};

// Calculate distance from a point to a line segment
export const calculateDistanceToSegment = (point, lineStart, lineEnd) => {
  const lat = Number(point.latitude);
  const lon = Number(point.longitude);
  const lat1 = Number(lineStart.latitude);
  const lon1 = Number(lineStart.longitude);
  const lat2 = Number(lineEnd.latitude);
  const lon2 = Number(lineEnd.longitude);

  // Convert to Cartesian coordinates for simpler math
  const x = lon;
  const y = lat;
  const x1 = lon1;
  const y1 = lat1;
  const x2 = lon2;
  const y2 = lat2;

  const A = x - x1;
  const B = y - y1;
  const C = x2 - x1;
  const D = y2 - y1;

  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  let param = -1;

  if (lenSq !== 0) {
    param = dot / lenSq;
  }

  let xx, yy;

  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  // Convert back to lat/lon and calculate distance
  return calculateDistance(
    { latitude: lat, longitude: lon },
    { latitude: yy, longitude: xx }
  );
};

// Format distance for display
export const formatDistance = (distance) => {
  if (!distance) return '0 km';
  
  if (distance < 1) {
    // Convert to meters for small distances
    const meters = Math.round(distance * 1000);
    return `${meters}m`;
  }
  
  // Round to 1 decimal place for kilometers
  return `${distance.toFixed(1)}km`;
};

// Convert degrees to radians
const toRad = (degrees) => {
  return degrees * Math.PI / 180;
};